import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

const DIETS_AND_DIET_CATEGORIES_QUERY = gql`
  query dietsAndDietCategories {
    dietsAndDietCategories {
      results {
        id
        name
        isCurationEnabled
        level
        idPath
        namePath
        type
        position
        children {
          id
          name
          isCurationEnabled
          level
          idPath
          namePath
          type
          parentId
          position
        }
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
`

export default DIETS_AND_DIET_CATEGORIES_QUERY
